/*! data-type: counter */
(function() {
  'use strict';

  /* counter */
  let counter = document.querySelectorAll("[data-type='counter']");
  if (counter) {
    function counting(el) {
      let counter = el;
      let duration = el.dataset.duration ? el.dataset.duration : 2000;
      let start = el.dataset.start ? el.dataset.start : 0;
      let target = el.dataset.count;
      let value = start;
      let begin = 0;
      let dots = el.dataset.dots ? el.dataset.dots == 'true' : true;
      function writeNumber(x) {
        if (dots) {
          x = x.toString();
          var pattern = /(-?\d+)(\d{3})/;
          while (pattern.test(x)) {
            x = x.replace(pattern, "$1.$2");
          }
        }
        el.innerHTML = x;
      }
      function easeInOutCubic(t){
        return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1;
      };
      function count(now) {
        if (now >= begin + duration) {
          writeNumber(target);
        } else {
          writeNumber(Math.floor(begin + (target - begin) * easeInOutCubic((now - begin) / duration)));
          requestAnimationFrame(count);
        }
      }
      function startCounting(timestamp) {
        begin = timestamp;
        count(timestamp);
      }
      if (target) {
        requestAnimationFrame(startCounting);
      }
    }
    let observer = new IntersectionObserver(function(entries) {
      for (let i=0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          counting(entries[i].target);
          observer.unobserve(entries[i].target);
        }
      }
    },
    {
      threshold: [0.1],
      delay: 100
    });
    for (let i=0; i<counter.length; i++) {
      observer.observe(counter[i]);
    }
  }

})();
